import React from "react";
import {ReactComponent as VoiceIcon} from "./images/voice-icon.svg";
import {ReactComponent as ChatIcon} from "./images/chat-icon.svg";
import {Message} from "../../types/types";

type Props = {
  messages: Message[];
  isExpanded: boolean;
  inputValue: string;
  setInputValue: (val: string) => void;
  onSubmit: () => void;
};

const ChatInput: React.FC<Props> = ({
  inputValue,
  isExpanded,
  setInputValue,
  onSubmit,
  messages,
}) => {
  return (
    <div
      className={`iris-input-wrapper ${messages.length > 0 ? "active" : ""} ${
        isExpanded ? "activeDesktop" : ""
      }`}>
      <input
        type="text"
        name="iris-input"
        placeholder="How can I help?"
        className="iris-input"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSubmit();
          }
        }}
        aria-label="Chat input"
        autoComplete="off"
      />
      <button
        className="iris-mic-button"
        onClick={onSubmit}
        disabled={!inputValue.trim()}
        aria-label="Submit message">
        <span className="iris-mic-icon">
          {inputValue.trim() === "" ? <VoiceIcon /> : <ChatIcon />}
        </span>
      </button>
    </div>
  );
};

export default ChatInput;
